import React from 'react';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
  const links = (
    <>
      <NavLink to="/" end>Home</NavLink>
      <NavLink to="/photography">Photography</NavLink>
      <NavLink to="/design">Design</NavLink>
    </>
  );

  return (
    <>
      <nav className="navbar top-nav">{links}</nav>
      <nav className="navbar bottom-nav">{links}</nav>
    </>
  );
};

export default Navbar;